import { render } from "./UiBreadcrumbs.vue?vue&type=template&id=ad971540&ts=true"
import script from "./UiBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./UiBreadcrumbs.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__